import apiClient from './api';

export interface Currency {
  id?: number;
  code: string;
  name: string;
  symbol?: string;
  rate: number;
  status?: number | string;
  created_by?: number;
  updated_by?: number;
  created_at?: string;
  updated_at?: string;
}

export const currencyService = {
  // Get all currencies
  async getCurrencies(): Promise<Currency[]> {
    try {
      const response = await apiClient.get('/currencies');
      // The old CurrncyList.vue accessed response.data.data
      // Let's ensure we return the array directly. 
      return response.data.data || response.data;
    } catch (error) {
      console.error('Error fetching currencies:', error);
      throw error;
    }
  },

  // Get single currency by ID
  async getCurrency(id: number): Promise<Currency> {
    try {
      // The API endpoint might wrap data, returning response.data for uniformity
      const response = await apiClient.get(`/currencies/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching currency ${id}:`, error);
      throw error;
    }
  },

  // Create new currency
  async createCurrency(currency: Omit<Currency, 'id'>): Promise<Currency> {
    try {
      const response = await apiClient.post('/currencies', currency);
      return response.data;
    } catch (error) {
      console.error('Error creating currency:', error);
      throw error;
    }
  },

  // Update existing currency
  async updateCurrency(id: number, currency: Partial<Currency>): Promise<Currency> {
    try {
      const response = await apiClient.put(`/currencies/${id}`, currency);
      return response.data;
    } catch (error) {
      console.error(`Error updating currency ${id}:`, error);
      throw error;
    }
  },

  // Delete currency
  async deleteCurrency(id: number): Promise<void> {
    try {
      await apiClient.delete(`/currencies/${id}`);
    } catch (error) {
      console.error(`Error deleting currency ${id}:`, error);
      throw error;
    }
  },
};

export default currencyService;
